import { get } from 'lodash';
import { modifyAlpha } from '../../../../utils/modifyColour';

const styles = ({ color, fontSize, typography }) => ({
  authProviderType: {
    width: 200,
  },
  keyNameContainer: {
    marginTop: 20,
    marginBottom: 40,
  },
  inputFieldContainer: {
    display: 'block',
  },
  heading: {
    color: get(color, 'bodyText'),
  },
  inputField: {
    '& input': {
      margin: 0,
      padding: 10,
      border: `1px solid ${get(color, 'borderColor')}`,
      borderRadius: 3,
    },
  },
  notchedOutline: {
    outline: 0,
    border: 0,
  },
  inputHelpText: {
    color: get(color, 'bodyText'),
    margin: 1,
    marginTop: 8,
    marginBottom: 10,
  },
  secretHelpText: {
    backgroundColor: 'rgba(255, 148, 77, 0.1)',
    border: '1px solid #FF944D',
    borderRadius: 3,
    display: 'inline-flex',
    paddingBottom: 19,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 16,
    width: 420,
  },
  secretInfoWarningIcon: {
    marginRight: 6,
  },
  statusField: {
    '& legend': {
      color: `${get(color, 'bodyText')} !important`,
      fontFamily: `${get(typography, 'bodyText')} !important`,
      fontSize: `${get(fontSize, 'bodyText')} !important`,
      fontWeight: 'bold',
    },
    color: `${get(color, 'bodyText')} !important`,
    fontFamily: `${get(typography, 'bodyText')} !important`,
    fontSize: `${get(fontSize, 'bodyText')} !important`,
    marginBottom: 10,
  },
  statusLabel: {
    marginTop: 12,
  },
  helperText: {
    color: `${get(color, 'smallText')} !important`,
    fontFamily: `${get(typography, 'smallText')} !important`,
    fontSize: `${get(fontSize, 'smallText')} !important`,
  },
  helpIcon: {
    fontSize: 16,
    marginLeft: 10,
    verticalAlign: 'middle',
  },
  sectionTitle: {
    color: get(color, 'bodyText'),
    fontFamily: get(typography, 'buttonText'),
    // fontSize: get(fontSize, 'bodyText'),
    fontWeight: 'bold',
    fontSize: '1.12em',
  },
  lockingWarning: {
    color: `${get(color, 'smallText')} !important`,
    fontFamily: `${get(typography, 'smallText')} !important`,
    fontSize: `${get(fontSize, 'smallText')} !important`,
    display: 'inline-flex',
  },
  defaultCheckboxContainer: {
    color: `${get(color, 'bodyText')} !important`,
    fontFamily: `${get(typography, 'bodyText')} !important`,
    fontSize: `${get(fontSize, 'bodyText')} !important`,
    fontWeight: 'bold',
    marginTop: -20,
  },
  checkboxHelpText: {
    color: `${get(color, 'bodyText')} !important`,
    fontFamily: `${get(typography, 'bodyText')} !important`,
    fontSize: `${get(fontSize, 'bodyText')} !important`,
    marginBottom: 20,
    marginTop: -10,
  },
  defaultKeyWarningText: {
    marginTop: -20,
    marginBottom: 20,
    fontFamily: `${get(typography, 'smallText')} !important`,
    fontSize: `${get(fontSize, 'smallText')} !important`,
    color: get(color, 'warning'),
  },
  secretType: {
    marginLeft: 40,
    width: 240,
    marginTop: '12px !important',
    marginBottom: '12px !important',
  },
  selectField: {
    width: 200,
    marginTop: '12px !important',
    marginBottom: '12px !important',
  },
  secretTypeErrorText: {
    marginTop: -5,
    marginBottom: 5,
    color: get(color, 'error'),
  },
  generateSecretDialog: {
    fontFamily: `${get(typography, 'bodyText')} !important`,
    color: get(color, 'bodyText'),
    margin: 20,
    width: 500,
  },
  generateSecretDialogContent: {
    fontSize: `${get(fontSize, 'bodyText')} !important`,
  },
  keyDetails: {
    overflowY: 'scroll',
    height: 'calc(100vh - 250px)',
    paddingTop: 0,
    paddingLeft: 4,
  },
  showDetails:{
    maxHeight: 'calc(100vh - 250px)',
    transition: 'max-height 0.7s, overflow 0.7s 0.7s',
  },
  hideDetails:{
    maxHeight: 0,
    overflow: 'hidden',
    transition: 'max-height 0.7s, overflow 0.7s 0.7s',
  },
  errorBackgroundButton: {
    backgroundColor: get(color, 'error'),
    color: get(color, 'bodyBackground'),
    '&:hover': {
      color: get(color, 'bodyBackground'),
      backgroundColor: modifyAlpha(get(color, 'error'), '0.7'),
    },
    '&:focus': {
      outlineWidth: '1px !important',
      outlineOffset: '-4px !important',
      outlineStyle: 'solid !important',
      outlineRadius: '3px !important',
    },
    marginRight: 20,
  },
  fieldCopyContainer:{
    display: 'inline-flex',
    width: '100%',
  },
  footer: {
    paddingTop: 20,
    paddingBottom: 20,
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'flex-end',
  },
  cancelButton: {
    '&:focus': {
      outlineWidth: '1px !important',
      outlineOffset: '-4px !important',
      outlineStyle: 'solid !important',
      outlineRadius: '3px !important',
    },
  },
  dialogButtonPanel: {
    marginTop: 30,
    float: 'right',
  },
  headingLine: {
    display: 'inline-flex',
    marginTop: 40,
    width: '100%',
    justifyContent: 'space-between',
  },
  headingAndDelete: {
    display: 'inline-flex',
  },
  generateSecretMenuButton: {
    border: `1px solid ${get(color, 'borderColor')}`,
    color: get(color, 'error'),
    '&:hover': {
      color: get(color, 'error'),
    },
    '&:focus': {
      border: `1px solid ${get(color, 'error')}`,
    },
    marginBottom: 50,
  },
  keyEditDialog: {
    height: '100%',
  },
  deleteKeyButton: {
    border: `1px solid ${get(color, 'borderColor')}`,
    color: get(color, 'error'),
    '&:hover': {
      color: get(color, 'error'),
    },
    '&:focus': {
      outlineWidth: '1px !important',
      outlineOffset: '-4px !important',
      outlineStyle: 'solid !important',
      outlineRadius: '3px !important',
      outlineColor: get(color, 'borderColor'),
    },
    marginLeft: 10,
    marginTop: 10,
  },
  alertSubmitButton: {
    backgroundColor: `${get(color, 'error')} !important`,
    borderColor: `${get(color, 'error')} !important`,
  },
  warningIcon: {
    fill: get(color, 'warning'),
    marginLeft: 5,
  },
  notificationWidthClass: {
    width: '79%',
    padding: '0 10px',
    marginLeft: 0,
  },
  deleteConfirmPanel: {
    marginLeft: 10,
    marginTop: 10,
  },
  secretOptionsContainer: {
    color: get(color, 'bodyText'),
  },
  textField: {
    width: '70%',
  },
  copyButton: {
    color: get(color, 'primaryButtonBackground'),
    marginTop: 51,
    width: '20%',
    '&:focus': {
      outlineWidth: '1px !important',
      outlineOffset: '-4px !important',
      outlineStyle: 'solid !important',
      outlineRadius: '3px !important',
      outlineColor: get(color, 'borderColor'),
    },
  },
  saveButton: {
    marginBottom: 10,
  },
  closeButton: {
    marginBottom: 10,
    marginLeft: 10,
    '&:focus': {
      outlineWidth: '1px !important',
      outlineOffset: '-4px !important',
      outlineStyle: 'solid !important',
      outlineRadius: '3px !important',
    },
  },
  iconRoot: {
    '& svg': {
      width: 16,
      height: 16,
    },
  },
  closeIconButton: {
    minWidth: 0,
    width: 35,
    height: 35,
    padding: 0,
    marginTop: 10,
    '&:focus': {
      outlineWidth: '1px !important',
      outlineOffset: '-4px !important',
      outlineStyle: 'solid !important',
      outlineRadius: '3px !important',
    },
  },
  authMethodSelectContainer: {
    display: 'inline-flex',
  },
  statusRadioGroup: {
    display: 'inline-flex',
    flexDirection: 'row',
  },
  dcrTextAreas: {
    display: 'flex',
    marginRight: 16,
  },
  halfDiv: {
    width: '49%',
    marginTop: '12px !important',
    marginBottom: '6px !important',
  },
  fullDiv: {
    width: '100%',
    marginTop: '12px !important',
    marginBottom: '6px !important',
  },
  clientDefSelection: {
    display: 'flex',
    marginRight: 16,
    width: '100%',
  },
  clientDefDropdown: {
    marginTop: '0px !important',
    marginBottom: '0px !important',
  },
  clientDefButtons: {
    alignContent: 'space-between',
    marginLeft: 24,
    display: 'flex',
    marginRight: 8,
    alignItems: 'end',
    width: '50%',
  },
  expandButton: {
    marginBottom: 10,
    float: 'right',
    '&:focus': {
      backgroundColor: get(color, 'borderColor'),
    },
    marginLeft: 'auto',
    marginRight: 16,
  },
  cdDesc: {
    marginLeft: 24,
  },
  paperClass: {
    padding: 32,
    paddingTop: 0,
    height: 250,
    maxHeight: 'calc(100% - 200px)',
    width: 250,
  },
});

export default styles;
